module.exports = __webpack_public_path__ + "img/ic_phone_white.1e9d7882.svg";